import { inputLengthValidator } from './inputLengthValidator';

interface PasswordValidator {
  (password: string): boolean;
}

export const passwordValidator: PasswordValidator = (password) => {
  const isValidPassword = inputLengthValidator(password, 8);
  if (!isValidPassword) {
    return false;
  }
  const isCorrectPassword =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()\-_=+{};:,<.>]).{8,}$/.test(password);
  return isValidPassword && isCorrectPassword;
};
